import React, { Component } from 'react'
import {Button, Form, Icon, Table, Popup} from "semantic-ui-react";
import { DropzoneComponent } from 'react-dropzone-component';
import { deleteQueryImage } from '../../data/dashboard_api';
import * as unavailable from "../../assets/photo_unavailable.jpg";

export default class AddCustomerServiceItem extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }
    
  render() {
    let item = this.props.item
    let roomIndex = this.props.roomIndex
    let groupIndex = this.props.groupIndex
    let itemIndex=this.props.itemIndex
    
    let dropZone = null;
        const componentConfig = {postUrl: 'no-url'};

        let djsConfig = {
            autoProcessQueue: false,
            addRemoveLinks: true,
            acceptedFiles: "image/*",
        };
        const eventHandlers = {
            init: (dropzone) => {
                dropZone = dropzone;
                dropZone.autoDiscover = false;
            },
            addedfile: (file) => {
                if(file.type.startsWith("image/")){
                    this.props.addItemImage(file,roomIndex,groupIndex,itemIndex)
                    this.setState({imageError:false})
                }
                else {
                    this.setState({imageError:true})
                }
            },

            removedfile: (file) => {
                this.props.removeItemImage(file,roomIndex,groupIndex,itemIndex)                   
            }
        };
        

        
        
    
    
    return (
        <Table id={`item_${item.itemIndex}`} style={{marginBottom:"15px"}}color="blue" fixed celled compact>
        <Table.Header>
        <Table.Row>
            <Table.HeaderCell><Button primary compact basic size="mini" onClick={(e)=>{e.preventDefault()}}><Icon name="hashtag"></Icon>{item.itemIndex}</Button></Table.HeaderCell>
            <Table.HeaderCell colSpan={3}textAlign='right'> 
            {!item.selected ? <Button compact basic color="green" icon size="mini" onClick={(e)=>{this.props.toggleList(e,roomIndex,groupIndex,itemIndex)}}><Icon name="plus"></Icon>Add To List</Button>:<Button compact basic color="red" icon size="mini" onClick={(e)=>{this.props.toggleList(e,roomIndex,groupIndex,itemIndex)}}><Icon name="minus"></Icon>Remove From List</Button>}  </Table.HeaderCell>
        </Table.Row>
        </Table.Header>
        <Table.Body>
        {item.selected && <Table.Row>
            <Table.Cell><strong>Location</strong></Table.Cell>
            <Table.Cell colSpan={3}>
            <Button onClick={(e)=>{e.preventDefault()}} compact basic color="green" size="mini">{item.room}</Button>
            <Button onClick={(e)=>{e.preventDefault()}} compact basic color="orange" size="mini">{item.group}</Button></Table.Cell>
        </Table.Row>}
        <Table.Row>
            <Table.Cell><strong>Item Description</strong></Table.Cell>
            <Table.Cell colSpan={3}>{item.name}</Table.Cell>
        </Table.Row>
        {this.props.expanded && <Table.Row>
            <Table.Cell><strong>CI Notes</strong></Table.Cell>
            <Table.Cell colSpan={3}>{item.ci_notes?item.ci_notes : "No dilapidations found"}</Table.Cell>
        </Table.Row>}
       {this.props.expanded && this.props.isCo && <Table.Row>
            <Table.Cell><strong>CO Notes</strong></Table.Cell>
            <Table.Cell colSpan={3}>{item.co_notes?item.co_notes : "No changes from CI"} {item.flag && <Button onClick={e =>{e.preventDefault()}}compact size="mini" basic color="orange">{item.flag}</Button>}
            {item.additional_co_notes > 0?<Popup trigger={<Button icon="list" labelPosition='left' compact size="mini" content={"Additional Notes"} basic onClick={e =>{e.preventDefault()}} color="grey"/>}>
                <ul>{item.additional_co_notes.map((note) =>{return <li>{note.co_notes} {note.flag && <Button onClick={e =>{e.preventDefault()}}compact size="mini" basic color="orange">{note.flag}</Button>} </li>})}</ul>
            </Popup>:null}
            </Table.Cell>
        </Table.Row>}
{item.selected && <Table.Row>
            <Table.Cell><strong>Your Comments</strong></Table.Cell>
            <Table.Cell colSpan={3}><Form.TextArea defaultValue={this.props.item.comment || ""} onBlur={e=>{this.props.updateComment(e,roomIndex,groupIndex,itemIndex)}}></Form.TextArea></Table.Cell>
        </Table.Row>}
      {item.selected && <Table.Row>
            <Table.Cell><strong>Your Photos</strong></Table.Cell>
            <Table.Cell colSpan={3}>
                <DropzoneComponent config={componentConfig} style={{ minHeight: 250 }}
                eventHandlers={eventHandlers} djsConfig={djsConfig}/>
            </Table.Cell>
        </Table.Row>}
        </Table.Body>
        </Table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/inspection/add_customer_service_item.js